import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "acts-status-bar q-px-lg q-py-sm row" }
const _hoisted_2 = { class: "acts-status-bar__item" }
const _hoisted_3 = { class: "acts-status-bar__item" }


import {
  computed, PropType,
} from 'vue';
import type { IAct } from '@/store/contracts/types';
import { getSumByField } from '@/utils/getSumByField';

const __default__ = {
  name: 'ActStatusBar',
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  acts: {
    type: Array as PropType<IAct[]>,
    default: () => [],
  },
},
  setup(__props) {

const props = __props



const actsSum = computed<number>(() => getSumByField(props.acts, 'sum_act'));
const paymentsSum = computed<number>(() => getSumByField(props.acts, 'sum_pay'));
const balance = computed<number>(() => paymentsSum.value - actsSum.value);
const balanceColor = computed<string>(() => (balance.value >= 0 ? 'green' : 'red'));


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, " Итого стоимость: " + _toDisplayString(_unref(actsSum)) + "р. ", 1),
    _createElementVNode("div", _hoisted_3, " Итого оплачено: " + _toDisplayString(_unref(paymentsSum)) + "р. ", 1),
    _createElementVNode("div", {
      class: "acts-status-bar__item",
      style: _normalizeStyle({color: _unref(balanceColor)})
    }, " Баланс: " + _toDisplayString(_unref(balance)) + "р. ", 5)
  ]))
}
}

})